export default __webpack_public_path__ + "04751682fea03b5ed90448aaae4d1bb7.svg";